module.exports = __webpack_public_path__ + "static/img/sccar-BLP8sjMY.c0c4c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/sccar-BLP8sjMY.png
// module id = Zpwm
// module chunks = 16